import React, { useState } from 'react';
import { LoggerService } from '../../shared/services/logger.service';

/**
 * Banner de autenticación mock
 * Muestra las credenciales de prueba cuando Firebase no está configurado
 */
export const MockAuthBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Solo mostrar si Firebase no está configurado
  const isFirebaseConfigured = !!(
    import.meta.env.VITE_FIREBASE_API_KEY && 
    import.meta.env.VITE_FIREBASE_PROJECT_ID
  );

  if (isFirebaseConfigured || process.env.NODE_ENV === 'production') {
    return null;
  }

  const handleDismiss = () => {
    setIsVisible(false);
    LoggerService.info('Mock auth banner dismissed', 'MockAuthBanner');
  };

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="fixed top-4 right-4 bg-blue-600 text-white px-3 py-2 rounded-lg shadow-lg hover:bg-blue-700 z-50"
      >
        🔑 Credenciales Mock
      </button>
    );
  }

  return (
    <div className="fixed top-4 right-4 bg-yellow-100 border border-yellow-400 rounded-lg p-4 shadow-lg z-50 max-w-sm">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-bold text-yellow-800 mb-2">🔑 Autenticación Mock</h3>
          <p className="text-sm text-yellow-700 mb-3">
            Firebase no está configurado. Usa estas credenciales de prueba:
          </p>
          
          <div className="space-y-2 text-sm">
            <div className="bg-white p-2 rounded border">
              <strong>Usuario:</strong> test@invirtiendo.com<br/>
              <strong>Contraseña:</strong> test123456
            </div>
            
            <div className="bg-white p-2 rounded border">
              <strong>Admin:</strong> admin@invirtiendo.com<br/>
              <strong>Contraseña:</strong> test123456
            </div>
          </div>
          
          <p className="text-xs text-yellow-600 mt-2">
            Los datos son simulados y se reinician al recargar la página.
          </p>
        </div>
        
        <button
          onClick={handleDismiss}
          className="text-yellow-600 hover:text-yellow-800 ml-2"
        >
          ✕
        </button>
      </div>
    </div>
  );
};
